<template>
    <div class="wp">
        <div class="w-1200 s-1">
            <div class="title-more">
                <div class="t-m-blue"></div>
                <p class="t-m-t">保障中心</p>
                <el-dropdown class="type-all-box pull-right" @command="handleCommand">
                    <span class="btn">全部分类</span>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item v-for="(item, index) in typeAll" :key="index" :command="item.code">{{item.name}}</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
                <div class="type-list pull-right">
                    <div v-for="(item, index) in typeTop" :key="index"
                        class="item"
                        :class="{active: typeCode == item.code}"
                        @click="setTypeCode(item.code)">{{item.name}}</div>
                </div>
            </div>
            <div v-for="(item, index) in list" :key="index" class="pointer s-1-item" @click="showPostSale(item.sslmCode,item.id)">
                <div class="img">
                    <el-image style="width: 100%; height: 100%;" :src="item.sctp" fit="contain">
                        <div v-if="item.sslmCode == 16" slot="error" style="width: 100%; height: 100%;" class="image-slot">
                           <img style="object-fit: contain;width: 100%; height: 100%;" src="../../assets/image/home/pingjia.jpg">
                        </div>
                    </el-image>
                    <!-- <img :src="item.sctp"> -->
                </div>
                <div class="intro">
                    <p class="p1" >{{item.cpmc}}</p>
                    <p class="p2">
                        <span>评价单位：{{item.pjdw}}</span>
                        <span style="padding-left:20px;">评价人：{{item.pjr}}</span>
                        <span style="padding-left:20px;">发表时间：{{item.createDate}}</span>
                    </p>
                    <p class="p3">{{item.infoTitle}}</p>
                    <div class="eva" v-if="item.sslmCode == 16">
                        <p class="p4 pull-left">售后评分：</p><el-rate v-model="item.pf" disabled style="width:200px;float:left;"></el-rate>
                        <p class="p4 pull-right">
                            <!-- @click="$refs.commentDialog.open()" -->
                            <span class="comment-btn">留言评价</span>
                            {{item.lyNum}}
                        </p>
                    </div>
                </div>
            </div>
            <z-page :pageObj="page" @changePage1="changePage"></z-page>
        </div>

        <comment-dialog ref="commentDialog"></comment-dialog>
    </div>
</template>
<script>
import Safeguard from './Safeguard.js';
export default Safeguard;
</script>
<style lang="scss" scoped>
@import './Safeguard.scss';
</style>